import { AvatarGroup } from '@natu/ui/AvatarGroup';

import {
  type SBProps,
  sbEditable,
  type StoryblokAsset,
  getAssetFromStoryblok,
} from '../../../../utils';

interface SBAvatarGroupProps {
  images?: StoryblokAsset[];
  withHover?: boolean;
}

export const SBAvatarGroup = ({ blok }: SBProps<SBAvatarGroupProps>) => {
  const { images, withHover } = blok;

  const avatars = images?.map(image => getAssetFromStoryblok(image, { type: 'image' }));

  return <AvatarGroup images={avatars} withHover={withHover} {...sbEditable(blok)} />;
};
